import getters from './getters';
import actions from './actions';
import mutations from './mutations';
export var state = function state() {
  return {
    lookbook: {},
    products: {},
    current: '',
    loading: false
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};